import React, { useEffect, useState } from 'react';
import { useForm } from 'hooks';
import { Page } from 'components/common';
import { 
  FormGroup,
  SubmitButton,
  BackButton,
} from 'components/common/Forms';
import { objectToIndexedFormData } from 'services';
import shortid from 'shortid';
import { NotificationManager } from 'react-notifications';
import LogoUpload from 'pages/Installers/LogoUpload';
import {map, assign,join, omit} from 'lodash';

export const Edit = ({ 
  match,
  client,
  url = 'white-label-partners',
  readOnly,
  history
}) => {
  const { Form, Control, model, actions, dispatch, setValue, load, loaded, setRefreshToken } = useForm();

  const { id } = match.params;
  const fetchUrl = id === 'new' ? url : url + '/' + id;

  const [logo, setLogo] = useState(null);
  const [data, setData] = useState({});
  const onFileDrop = accepted => setLogo(accepted[0]);

  const renderServerError = e => {e}; //noop

  useEffect(async () => {
    if(id !== 'new') {
      const item = await client.get(fetchUrl).get('data');
      setData(item);
      setValue({
        ...item,
        'employerIds':join(map(item.employerIds, 'employer_id')),
      });
    } else {
      setValue({});
    }
  }, []);

  async function onSubmit(data) {
    try {
      data = Object.assign({}, data);
      if (logo) {
        data = objectToIndexedFormData(data);
        data.append('logo_image_file', logo);
      } else {
        data = omit(data, 'logo_image_file') 
      }
      if(id !== 'new') {
        await client.put(fetchUrl, data);
        NotificationManager.success('Updated successfully');
      } else {
        await client.post(fetchUrl, data);
        NotificationManager.success('Saved successfully');
      }
    } finally {
      dispatch(actions.setPending('local', false));
      history.goBack()
    }
  }

  if (!loaded) return null;

  return (
    <Page title={`${id === 'new' ? "New" : "Edit"} ${data.default ? 'Default' : ''} White Label Partner`}>
      <Form
        onSubmit={onSubmit}
      >
        <FormGroup label="Partner Name *" model=".name">
          <Control.text model=".name" className="form-control" />
        </FormGroup>
        {data.default ? '' : 
          <FormGroup label="Employer ID's *" model=".employerIds">
            <Control.text model=".employerIds" className="form-control" />
          </FormGroup>
        }
        <LogoUpload
          item={data}
          logo={logo}
          onFileDrop={onFileDrop}
          readOnly={readOnly}
          renderServerError={renderServerError}
        />
        <div className="flex justify-end">
          <BackButton onClick={history.goBack} />
          <SubmitButton className="ml-2 mr-2">Save</SubmitButton>
        </div>
      </Form>
    </Page>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/pages/WhiteLabelPartners/Edit.js